import _ from 'lodash';
import moment from 'moment';
import tinyColor from 'tinycolor2';
import { addCssClass, sum } from './general';
import { statusColors, getStatus } from './vehicle';
import config from '../config';
import store from '../store';

const currencyCountryLookup = {
  USD: 'US',
  CAD: 'CA',
};

export function BranchArrayFormatter(data) {
  if (!data || !data.value || !Array.isArray(data.value)) {
    return '';
  }

  const { branches } = store.getState().app;

  // Make sure they are ints
  const value = data.value.map(v => parseInt(v));

  const hasAll = branches.every(b => {
    return value.includes(b.id);
  });

  if (hasAll) {
    return 'All Branches';
  }

  const branchNames = value.map(v => branches.find(b => b.id === v)?.name);

  return branchNames.join(', ');
}

export function ColorCellRenderer() {}
ColorCellRenderer.prototype.init = function (params) {
  this.eGui = document.createElement('div');

  if (!params.data) {
    return;
  }

  const backgroundColor = params.data?.backgroundColor || params.value;
  this.eGui.style.backgroundColor = backgroundColor;
  this.eGui.style.color = params.data?.textColor || tinyColor(backgroundColor).isDark() ? '#fff' : '333';
  this.eGui.style.textAlign = 'center';
  this.eGui.style.fontWeight = 'bold';

  const span = document.createElement('span');
  span.textContent = params.value.toUpperCase();
  this.eGui.appendChild(span);
};

ColorCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

export function BooleanCellRenderer() {}
BooleanCellRenderer.prototype.init = function (params) {
  this.eGui = document.createElement('span');
  const icon = document.createElement('i');

  if (params.value === true || params.value === 'Y') {
    icon.className = 'far fa-check';
    icon.style.color = 'var(--green-5)';
  } else {
    icon.className = 'far fa-times';
    // icon.style.color = 'var(--red-5)';
  }

  this.eGui.appendChild(icon);
};

BooleanCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

export function CountryCellRenderer() {}
CountryCellRenderer.prototype.init = function (params) {
  const value = params?.value || 'us';
  this.eGui = document.createElement('span');
  const img = document.createElement('img');
  img.src = `/img/flags/${value.toLowerCase()}.svg`;
  this.eGui.appendChild(img);
};

CountryCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

export function CurrencyCountryCellRenderer() {}
CurrencyCountryCellRenderer.prototype.init = function (params) {
  const value = params?.value || 'USD';
  const country = currencyCountryLookup[value];
  this.eGui = document.createElement('span');
  const img = document.createElement('img');
  img.src = `/img/flags/${country.toLowerCase()}.svg`;
  this.eGui.appendChild(img);
};

CurrencyCountryCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

// StatusCellRenderer is used when the object is available via PSQL join
export function StatusCellRenderer() {}
StatusCellRenderer.prototype.init = function (params) {
  this.eGui = document.createElement('div');
  const backgroundColor = params?.value?.color || statusColors[getStatus(params.value)] || '#fff';
  this.eGui.style.backgroundColor = backgroundColor;
  this.eGui.style.color = tinyColor(backgroundColor).isDark() ? '#fff' : '#333';
  this.eGui.style.textAlign = 'center';
  this.eGui.style.fontWeight = 'bold';

  const span = document.createElement('span');
  span.textContent = params?.value?.name || params.value;
  this.eGui.appendChild(span);
};

StatusCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

// StatusCodeRenderer is used when the code is available in redux because QM holds the record using it
export function StatusCodeRenderer() {}
StatusCodeRenderer.prototype.init = function (params) {
  this.eGui = document.createElement('div');

  if (params.value === '' || params.value === null) {
    return;
  }
  const { codes } = store.getState().app;

  if (!codes || !codes.length) {
    return;
  }

  const code = codes.find(c => c.id === parseInt(params.value));

  if (!code) {
    return;
  }

  const backgroundColor = code.color || 'transparent';

  this.eGui.style.backgroundColor = backgroundColor;
  this.eGui.style.color = tinyColor(backgroundColor).isDark() ? '#fff' : '#333';
  this.eGui.style.textAlign = 'center';
  this.eGui.style.fontWeight = 'bold';

  const span = document.createElement('span');
  span.textContent = code.name || params.value;
  this.eGui.appendChild(span);
};

StatusCodeRenderer.prototype.getGui = function () {
  return this.eGui;
};

export function StatusCodeComparator(valueA, valueB) {
  const { codes } = store.getState().app;

  const emptyOrder = { order: 0 };
  const codeA = valueA ? codes.find(c => c.id === parseInt(valueA)) || emptyOrder : emptyOrder;
  const codeB = valueB ? codes.find(c => c.id === parseInt(valueB)) || emptyOrder : emptyOrder;

  return codeA.order - codeB.order;
}

export function StatusComparator(valueA, valueB) {
  if (valueA === undefined || valueA === null) {
    valueA = { order: '0' };
  }

  if (valueB === undefined || valueB === null) {
    valueB = { order: '0' };
  }

  if (valueA.order) {
    return valueA.order - valueB.order;
  }

  if (!valueA.toLowerCase || !valueB || !valueB.toLowerCase) {
    return true;
  }

  // Fall back if the statusOrder column is not here
  return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
}

export function ImageCellRenderer() {}
ImageCellRenderer.prototype.init = function (params) {
  if (!params.value) {
    const wrapper = document.createElement('span');
    const icon = document.createElement('i');
    wrapper.className = 'ph-unit';

    const type = _.get(params, 'data.Type');
    icon.className = 'fas fa-fw';
    if (type === 'TLR') {
      icon.className += ' fa-trailer';
      icon.title = 'Trailer';
    } else if (type === 'REF') {
      icon.className += ' fa-refrigerator';
      icon.title = 'Reefer';
    } else if (type === 'EQP') {
      icon.className += ' fa-car-battery';
      icon.title = 'Equipment';
    } else {
      icon.className += ' fa-truck-container';
      icon.title = 'Truck';
    }

    this.eGui = wrapper;
    this.eGui.appendChild(icon);
    return;
  }

  const wrapper = document.createElement('a');
  wrapper.className = 'img-wrap';
  wrapper.href = `${config.serverUrl}/api/attachment/${params.value}/download`;
  wrapper.target = '_new';

  const img = document.createElement('img');
  img.src = `${config.serverUrl}/api/attachment/${params.value}/thumbnail?resize=80x`;

  this.eGui = wrapper;
  this.eGui.appendChild(img);
};

ImageCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

export function MoreOptionsRenderer() {}
MoreOptionsRenderer.prototype.init = function (params) {
  this.eGui = document.createElement('div');
  this.eGui.className = 'cell-flex-container';

  if (!params.value) {
    return;
  }

  const span = document.createElement('span');
  span.textContent = params.value;
  this.eGui.appendChild(span);

  const icon = document.createElement('icon');
  icon.className = 'fas fa-ellipsis-v more-options';
  icon.addEventListener('click', event => {
    params.api.contextMenuFactory.hideActiveMenu();
    params.api.contextMenuFactory.showMenu(params.node, params.column, params.value, event);
  });

  this.eGui.appendChild(icon);
};

MoreOptionsRenderer.prototype.getGui = function () {
  return this.eGui;
};

export function BasicCellRenderer() {}
BasicCellRenderer.prototype.init = function (params) {
  const isEditable = params?.colDef?.editable === true;
  const hasHelpers = params?.colDef?.helpers && params.colDef.helpers.length > 0;
  const hasOptions = params?.colDef?.options && params.colDef.options.length > 0;

  this.eGui = document.createElement('div');
  this.eGui.className = 'cell-flex-container';

  params.value = params.value || '';

  const cellValue = params.value.value || params.value;
  let displayValue = cellValue;

  if (hasOptions) {
    const option = params.colDef.options.find(o => o.value === cellValue);
    if (option && option.label) {
      displayValue = option.label;
    }
  }

  const span = document.createElement('span');
  span.textContent = displayValue;
  this.eGui.appendChild(span);

  if (isEditable) {
    const icon = document.createElement('icon');
    icon.className = 'fas fa-square editable';
    icon.title = 'Editable Cell';
    this.eGui.appendChild(icon);
  }

  if (hasHelpers && cellValue) {
    const icon = document.createElement('icon');
    icon.className = 'fas fa-ellipsis-v more-options';
    icon.addEventListener('click', event => {
      params.api.contextMenuFactory.hideActiveMenu();
      params.api.contextMenuFactory.showMenu(params.node, params.column, cellValue, event);
    });
    this.eGui.appendChild(icon);
  }
};

BasicCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

/*
  Ag-Grid removes animation class to a hardcoded one second
  This just reproduces how it works
*/
export function CustomAnimationRenderer() {}
CustomAnimationRenderer.prototype.init = function (params) {
  this.eGui = document.createElement('div');
  this.eValue = document.createElement('span');
  this.eValue.textContent = params.valueFormatted ? params.valueFormatted : params.value;
  this.eGui.appendChild(this.eValue);
};

CustomAnimationRenderer.prototype.getGui = function () {
  return this.eGui;
};

CustomAnimationRenderer.prototype.refresh = function (params) {
  this.eValue.textContent = params.valueFormatted ? params.valueFormatted : params.value;

  // prevent unhandled exceptions when grouping + filtering
  if (params.node.group) {
    return true;
  }

  const element = params.eGridCell;
  const cellChanged = 'ag-cell-data-changed-custom';

  addCssClass(element, cellChanged);

  const updateHistory = params.node.data.updateHistory || {};
  const { field } = params.colDef;
  updateHistory[field] = Date.now();
  params.node.data.updateHistory = updateHistory;

  // Flash row belonging to cell
  params.api.flashCells({ rowNodes: [params.node] });

  return true;
};

export function CurrencyFormatter(col) {
  if (col.value === undefined || col.value === null) {
    return '';
  }

  const value = typeof col.value === 'number' ? col.value : Number(col.value.replace(/[$,]/g, ''));
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function CurrencyAggFunc(params) {
  return params.values.reduce((accumulator, currentValue) => (parseFloat(currentValue) || 0) + accumulator, 0);
}

export function UserValueFormatter(col) {
  if (!col.value || (!col.value.firstName && !col.value.lastName && !col.value.username)) {
    return '';
  }

  if (col.value.firstName || col.value.lastName) {
    return `${col.value.firstName} ${col.value.lastName}`;
  }

  return col.value.username;
}

export function BasicDateValueFormatter(col) {
  if (!col.value) {
    return '';
  }
  return moment(new Date(col.value)).format('lll');
}

export function FromNowValueFormatter(col) {
  if (!col.value) {
    return '';
  }
  return moment(new Date(col.value)).fromNow();
}

export function padRepairOrder(value) {
  const parts = value.match(/([a-z]+)([0-9]+)/i);

  if (!parts || parts.length < 3) {
    return value;
  }

  return parts[1] + _.padStart(parts[2], 6, '0');
}

export function DateComparator(filterLocalDateAtMidnight, cellValue) {
  const dateAsString = cellValue;

  if (dateAsString == null) {
    return 0;
  }

  // This is assuming a YYYY-MM-DD cell value
  const cellDate = moment(cellValue).toDate();

  // Now that both parameters are Date objects, we can compare
  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
}

export function NumberComparator(a, b) {
  return Number(a || 0) - Number(b || 0);
}

export function AlphaNumericComparator(a, b) {
  return Number(String(a).replace(/\D/g, '')) - Number(String(b).replace(/\D/g, ''));
}

export const aggregate = {
  sum,
};

export function SmartSortComparator(a, b) {
  // When a cell is empty, agg correctly sends '' when sorting,
  // but INcorrectly sends null for empty cells when filtering.
  a = a ?? '';
  b = b ?? '';

  // do the simple stuff before regex analysis
  if (a === '' && b === '') return 0;
  if (a === '' && b !== '') return 1;
  if (a !== '' && b === '') return -1;
  if (!isNaN(a) && !isNaN(b)) {
    return a.localeCompare(
      b,
      {},
      {
        numeric: true,
      }
    );
  }
  // end speed tweaks

  // mixed string cases - see algorithm in issue #2783
  const regex = /[^\d]+|\d+/g;
  const ar = a.match(regex);
  const br = b.match(regex);
  let localeCompare;

  // eslint-disable-next-line
  for (const ia in ar) {
    // eslint-disable-next-line
    for (const ib in br) {
      let ari = ar[ib];
      if (ari === undefined) {
        ari = '';
      }
      let bri = br[ib];
      if (bri === undefined) {
        bri = '';
      }

      if (!isNaN(ari) && !isNaN(bri)) {
        localeCompare = ari.localeCompare(
          bri,
          {},
          {
            numeric: true,
          }
        );
      } else {
        localeCompare = ari.localeCompare(
          bri,
          {},
          {
            ignorePunctuation: true,
            sensitivity: 'base',
          }
        );
      }
      if (localeCompare !== 0) {
        return localeCompare;
      }
    }
  }
  return localeCompare;
}

// getSortModel is deprecated in v26+, but we still use it directly in a few places
// such as server side elasticsearch sorting when exporting large CSVs.
export function legacyGetSortModel(columnState) {
  if (!Array.isArray(columnState)) {
    return [];
  }

  const sortModel = [];
  for (const column of columnState) {
    if (column.sort) {
      sortModel.push({
        colId: column.colId,
        sort: column.sort,
      });
    }
  }

  return sortModel;
}

export function formatValue(value) {
  if (value && value.label) {
    return value.label;
  }

  return value;
}

export function getCellValue(value) {
  if (value && value.value) {
    return value.value;
  }

  return value;
}

export function getColumnDefs(headers = [], gridLayout) {
  const columnDefs = [];
  let hasSort = false;
  for (const field of headers) {
    if (field.sort) {
      hasSort = true;
    }

    const { style, name, label, hidden, ...rest } = field;
    const column = {
      cellClass: field.style || '',
      field: field.name || field.label,
      filter: field.filter,
      headerName: field.label,
      hide: field.hidden || false,
      ...rest,
    };

    if (
      field.type &&
      _.intersection(typeof field.type === 'string' ? [field.type] : field.type, [
        'number',
        'currencyColumn',
        'numberColumn',
      ]).length
    ) {
      column.filter = 'agNumberColumnFilter';
    }

    if (field.type === 'basicDateColumn') {
      column.filter = 'agDateColumnFilter';
    }

    // TODO Not needed in v26
    if (column.filterParams) {
      column.filterParams.newRowsAction = 'keep';
    } else {
      column.filterParams = { newRowsAction: 'keep' };
    }

    // Check for Set Filter in saved layout so the filter type can be updated
    if (_.get(gridLayout, `layout.f.${column.field}.filterType`) === 'set') {
      column.filter = 'agSetColumnFilter';
    }

    columnDefs.push(column);
  }

  if (columnDefs.length && !hasSort) {
    columnDefs[0].sort = 'asc';
  }

  return columnDefs;
}
